module.exports = __webpack_public_path__ + "img/boss.18621d9e.png";